<template>
<div class="chapter">
<div class="inner_page">
<p class="h1a">Contents</p>
<p class="noindent2"><a href="#/Text/acknowledgements">Acknowledgements</a></p>
<p class="noindent2"><a href="#/Text/introduction">Introduction</a></p>
<p class="noindent3"><a href="#/Text/chapter01">Chapter 1: Bleeding Kansas</a></p>
<p class="noindent2"><span href="#/Text/chapter02" title="Link target outside of Sample">Chapter 2: The Missouri Campaign</span></p>
<p class="noindent2"><span href="#/Text/chapter03" title="Link target outside of Sample">Chapter 3: Defeat at Westport</span></p>
<p class="noindent2"><span href="#/Text/chapter04" title="Link target outside of Sample">Chapter 4: Retreat From Kansas City</span></p>
<p class="noindent2"><span href="#/Text/chapter05" title="Link target outside of Sample">Chapter 5: Trading Post and Marais des Cygnes</span></p>
<p class="noindent2"><span href="#/Text/chapter06" title="Link target outside of Sample">Chapter 6: “Charge With Me, for God’s Sake!”</span></p>
<p class="noindent2"><span href="#/Text/chapter07" title="Link target outside of Sample">Chapter 7: “Boot to Boot, Stirrup to Stirrup”</span></p>
<p class="noindent2"><span href="#/Text/chapter08" title="Link target outside of Sample">Chapter 8: The Confederates Break and Run</span></p>
<p class="noindent2"><span href="#/Text/chapter09" title="Link target outside of Sample">Chapter 9: The Aftereffects</span></p>
<p class="noindent2"><span href="#/Text/chapter10" title="Link target outside of Sample">Chapter 10: Lieutenant Colonel Frederick Benteen’s After-Action Report</span></p>
<p class="noindent3"><span href="#/Text/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="noindent2"><span href="#/Text/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?7a589547